<script setup>
// imports
import {ref, reactive, onMounted} from 'vue'
import {useCartStore} from "../stores/CartStore";
import {modalStore} from "../stores/ModalStore";
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const cartStore = useCartStore();
const service = modalStore.service;
const category = modalStore.category;

import api from '../api';
import ToastComponent from "./ToastComponent.vue";

// data
const count = ref(0);
const data = reactive({
    serviceDetail: null
})

const currentUrl = window.location.pathname
const parts = currentUrl.split("/");
const slug = parts[parts.length - 1];
const isLoading = ref(true);

onMounted(async () => {
    await cartStore.checkLoginStatus();
    if (modalStore.service) {
        const path = `/api/add-services/show-detail/${modalStore.service.slug}`;
        await api.get(path)
            .then(response => {
                if (response.data) {
                    console.log('Service fetched successfully');
                    data.serviceDetail = response.data;

                }
            }).catch(function (error) {
                    console.error('Failed to fetch service: ', error);
                }
            );
    }
    isLoading.value = false;
})

function addToCart() {
    cartStore.addService(1, data.serviceDetail);
}
</script>
<template>
    <div v-if="!isLoading">
        <ToastComponent>
        </ToastComponent>
        <div class="container">
            <div v-if="modalStore.category" class="row mt-5 mb-5">
                <div class="col">
                    <h1>{{ modalStore.category }}</h1>
                    <h2 v-if="data.serviceDetail?.work_package" class="">Arbeitspaket /
                        {{ data.serviceDetail?.work_package_label }}</h2>
                    <h2 v-else-if="data.serviceDetail?.extracharge ||
                data.serviceDetail?.dailyrate || data.serviceDetail?.hourlyrate ">
                        Stunden / Tag</h2>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-md-8 col-12">
                    <a :href="'/images/' + data.serviceDetail.imagedir3 + data.serviceDetail.image3" data-fancybox>
                        <img
                            :src="'/images/' + data.serviceDetail.imagedir3 + data.serviceDetail.image3 + '?w=1200&h=600&fit=fill'"
                            alt="Ein Bild, das wahrscheinlich nicht so aussieht, wie du es dir vorstellst"
                            class="img-fluid"
                        >
                    </a>
                </div>
                <div class="col-md-4 col-12 mt-5">
                    <p>
                        <span class="small">ARTIKELNUMMER</span><br>
                        <strong>{{ data.serviceDetail?.article_number }}</strong>
                    </p>
                    <h2>{{ data.serviceDetail?.name }}</h2>
                    <div v-html="data.serviceDetail?.title"/>

                    <div v-html=" data.serviceDetail?.sub_line "/>
                    <div>
                        <strong>{{
                                (1 * data.serviceDetail?.price).toLocaleString('de-CH', {
                                    style: 'currency',
                                    currency: 'CHF'
                                })
                            }}</strong><br>
                        <strong v-if="data.serviceDetail?.price_description">{{
                                data.serviceDetail.price_description
                            }}</strong>
                    </div>
                    <div class="mb-3 mt-3">
                        <button class="btn btn-success" role="button"
                                aria-label="Warenkorb" title="zum Warenkorb hinzufügen"
                                @click="addToCart">
                            in den Warenkorb
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <section class="mb-5">
            <div class="accordion" id="serviceDetailAccordion">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne-serviceDetail">
                        <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne-serviceDetail"
                            aria-expanded="true"
                            aria-labelledby="headingOne-serviceDetail"
                            aria-controls="collapseOne-serviceDetail"
                        >
                            Wichtige Informationen / Bitte lesen !
                        </button>
                    </h2>
                    <div
                        id="collapseOne-serviceDetail"
                        class="accordion-collapse collapse show"
                        data-bs-parent="#serviceDetailAccordion"
                    >
                        <div class="accordion-body">
                            <div v-html="data.serviceDetail?.info_text"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<style scoped>
input {
    width: 4rem;
    text-align: center;
    display: inline-block;
}

.carousel-indicators button {
    width: .8rem;
    height: .8rem;
    border-radius: 100%;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>
